var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.555 6.94-3.85-3.645a1 1 0 0 0-1.435 0 1 1 0 0 0 0 1.41L12.77 7H1a1 1 0 0 0 0 2h11.755l-2.5 2.295a1.001 1.001 0 0 0 0 1.415 1.025 1.025 0 0 0 1.435 0l3.85-3.65a1.5 1.5 0 0 0 0-2.12h.015Z"
  })));
};
export default SvgArrowRight;